// extracted by mini-css-extract-plugin
export var colorSquare = "_nv-0";
export var container = "_nv-h";
export var danger = "_nv-5";
export var lightPink = "_nv-8";
export var neutralBlue = "_nv-7";
export var neutralYellow = "_nv-6";
export var normal = "_nv-1";
export var primary = "_nv-2";
export var primaryLight = "_nv-3";
export var selected = "_nv-i";
export var solidBlack = "_nv-g";
export var solidGreen = "_nv-b";
export var solidLightBlue = "_nv-d";
export var solidNavy = "_nv-c";
export var solidOrange = "_nv-f";
export var solidPink = "_nv-e";
export var solidRed = "_nv-9";
export var solidYellow = "_nv-a";
export var success = "_nv-4";